import React from 'react'
import { Alert } from 'react-bootstrap'
import { ImCancelCircle } from 'react-icons/im'

const NoticeAlert = ({ title, handleRemoveNotice, description }) => {

    console.log("title", title)
    console.log("description", description)
    return (
        <Alert variant="info">
            <div className="row">
                <div className="col">
                    <Alert.Heading>{title}</Alert.Heading>
                </div>
                <div className="col-auto">
                    <ImCancelCircle size={18} onClick={handleRemoveNotice} className='cursor-pointer' />
                </div>
            </div>
            <p className="mb-0">
                {description}
            </p>
        </Alert>
    )
}

export default NoticeAlert